import { IconProps, Icon } from '@bnb-chain/space';

export function PhantomIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" viewBox="0 0 24 24" fill="none" {...props}>
      <rect width="24" height="24" fill="white" />
      <g clipPath="url(#clip0_9685_21608)">
        <path
          d="M5.12645 19C7.41968 19 9.14307 17.0009 10.1716 15.4212C10.0465 15.7707 9.97696 16.1202 9.97696 16.4557C9.97696 17.3784 10.5051 18.0354 11.5475 18.0354C12.979 18.0354 14.5078 16.7773 15.3 15.4212C15.2444 15.617 15.2167 15.7987 15.2167 15.9664C15.2167 16.6095 15.578 17.0149 16.3146 17.0149C18.6357 17.0149 20.9706 12.891 20.9706 9.28426C20.9706 6.47437 19.5529 4 15.995 4C9.74071 4 3 11.6608 3 16.6095C3 18.5526 4.04238 19 5.12645 19ZM13.8407 8.97671C13.8407 8.27774 14.2299 7.78846 14.7997 7.78846C15.3556 7.78846 15.7448 8.27774 15.7448 8.97671C15.7448 9.67569 15.3556 10.1789 14.7997 10.1789C14.2299 10.1789 13.8407 9.67569 13.8407 8.97671ZM16.815 8.97671C16.815 8.27774 17.2041 7.78846 17.7739 7.78846C18.3299 7.78846 18.719 8.27774 18.719 8.97671C18.719 9.67569 18.3299 10.1789 17.7739 10.1789C17.2041 10.1789 16.815 9.67569 16.815 8.97671Z"
          fill="#AB9FF2"
        />
      </g>
      <defs>
        <clipPath id="clip0_9685_21608">
          <rect width="18" height="15" fill="white" transform="translate(3 4)" />
        </clipPath>
      </defs>
    </Icon>
  );
}
